/**
 * Términos resumidos — Grupo Bienestar CRM (SANTA ANA S.R.L. / Farma GSA).
 */

export const PULSE_ABOUT_LEGAL = {
  brandLine: 'Farma GSA',
  docTitle: 'Grupo Bienestar CRM',
  docSubtitle: 'Software propietario de SANTA ANA S.R.L. para operación interna del Grupo Santa Ana.',
  docVersion: 'Junio 2026',
  address: 'San Martín 951, Luján de Cuyo, Mendoza',
  territory: 'República Argentina · Operación farmacéutica en Provincia de Mendoza.',
  notice:
    'Texto institucional resumido para operadores. Revisión legal antes de publicación externa.',
  ownership: [
    'Todo el proyecto Grupo Bienestar CRM —código, diseño, flujos, integraciones, bases de datos y documentación— es propiedad exclusiva de SANTA ANA S.R.L.',
    'Queda prohibido copiar, distribuir, descompilar o usar el sistema sin autorización expresa del titular.'
  ],
  sections: [
    {
      num: 1,
      title: 'Titular y aceptación',
      paragraphs: [
        'SANTA ANA S.R.L. («Farma GSA») es titular de Pulse CRM. El acceso implica aceptación de estos términos. Solo personal autorizado del Grupo Santa Ana.'
      ]
    },
    {
      num: 2,
      title: 'Qué es Pulse CRM',
      bullets: [
        'Herramienta interna de gestión: pacientes, recetas, pedidos, conversaciones y coordinación operativa.',
        'Intermediación tecnológica; no reemplaza criterio médico ni farmacéutico.',
        'Dispensación y entrega: farmacias habilitadas en Mendoza, conforme normativa sanitaria vigente.'
      ]
    },
    {
      num: 3,
      title: 'Uso responsable',
      bullets: [
        'Datos veraces y uso conforme políticas internas y Ley 25.326.',
        'No es canal de emergencias: ante urgencia, derivar a 911 o guardia.',
        'Recetas bajo receta: validación profesional obligatoria.',
        'Horario referencial de pedidos: lun–vie 9–20 h, sáb 9–12 h; fuera de horario se procesa día hábil siguiente.'
      ]
    },
    {
      num: 4,
      title: 'Telemedicina y datos',
      paragraphs: [
        'Farma GSA no presta medicina ni emite recetas; lo hacen profesionales habilitados. Chats y registros pueden incluir datos de salud y se tratan con fines operativos, trazabilidad y cumplimiento normativo.'
      ]
    },
    {
      num: 5,
      title: 'Responsabilidad y ámbito',
      bullets: [
        'Pulse CRM se ofrece con disponibilidad razonable, sin garantía de servicio ininterrumpido.',
        'Farma GSA no responde por actos de farmacias, médicos, stock, demoras de terceros ni fuerza mayor.',
        'Ámbito geográfico de intermediación farmacéutica: Provincia de Mendoza.',
        'Jurisdicción: leyes de la República Argentina; tribunales de Mendoza.'
      ]
    },
    {
      num: 6,
      title: 'Contacto',
      paragraphs: [
        'Consultas y reclamos: canales oficiales del Grupo Santa Ana / área de sistemas. Modificaciones a estos términos se comunicarán por la Plataforma.'
      ]
    }
  ]
};
